module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/restore-page-6d6c2744fbb42288a04a42a503b1d31d.svg";